import { useCurrentSession } from "../currentSession";
import useSWR from "swr";
import { DashboardData, Link } from "@components/containers/ReportsPage/types";
import { P2P_DATA_MAP } from "@components/containers/ReportsPage/constants";
import { formatDateData } from "@components/util";
import moment from "moment";

const parseP2PData = (data: Array<Array<number>>): DashboardData => {
  const values: number[] = [];
  let results = {};

  data.forEach((arr) => {
    arr.forEach((item) => {
      if (typeof item === "number") values.push(item);
    });
  });

  results = P2P_DATA_MAP.links.map((link: Link, i: number) => ({
    ...link,
    value: values[i],
  }));

  return {
    ...P2P_DATA_MAP,
    links: results as Link[],
  };
};

const useGetSankeyData = ({
  startDate,
  endDate,
}: {
  startDate: moment.Moment;
  endDate: moment.Moment;
}) => {
  const { get, apiIsReady } = useCurrentSession();

  const fetcher: ({ url }: { url?: string }) => Promise<DashboardData> = async ({ url }) => {
    const response = await get(url!);
    return parseP2PData(response.data);
  };

  const start = formatDateData(startDate).split("T")[0];
  const end = formatDateData(endDate).split("T")[0];

  const {
    data,
    isLoading,
    error,
    isValidating,
    mutate,
  } = useSWR(
    apiIsReady
      ? { url: `${process.env.REPORTING_API}/sankey?startDate=${start}&endDate=${end}` }
      : null,
    ({ url }) => fetcher({ url }),
    {
      revalidateOnFocus: false,
      revalidateOnMount: false,
      revalidateOnReconnect: false,
      refreshWhenOffline: false,
      refreshWhenHidden: false,
      refreshInterval: 0,
    }
  );

  return {
    data,
    isLoading,
    error,
    isValidating,
    mutate,
  };
};

export default useGetSankeyData;
